module.exports = __webpack_public_path__ + "img/1.02.9fccf523.jpg";